import HighchartsReact from 'highcharts-react-official'
import React, { useState } from 'react'
import Highcharts, { color, Legend } from "highcharts";
import CustomDropDown from '../CustomDropDown';
import { Box, Typography } from '@mui/material';
import { amber, green, maroon } from '../../assets/colors';

const CustomPieChart = (props) => {
    const options = {
        chart: {
            type: "pie",
            size: '75%',
            // maxSize: 300,
            // minSize: 200,
            showInLegend: true,
            // marginTop: 15,
            // spacingTop: 0,
            // spacingBottom: 0,
            marginBottom: 90
        },
        title: {
            text: props?.data?.title
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            pie: {
                innerSize: "50%",
                showInLegend: true,
                dataLabels: {
                    enabled: false,}
            }
        },
        legend: {
            enabled: true,
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'bottom',
            floating: true,
            y:0,
            labelFormatter: function(){
                    const total = props?.data?.totalVotes
                    const percent = 
                    total === 0 ? 0 :
                    ((this.y/total) * 100).toFixed(0)
                    if( props.mode === 'Count')
                        return `${this.name}: ${this.y}`
                    else
                        return `${this.name}: ${percent}%`
                }
        },
        tooltip:{
            pointFormatter: function(){
                    const total = props?.data?.totalVotes
                    const percent = 
                    total === 0 ? 0 :
                    ((this.y/total) * 100).toFixed(0)
                    if( props.mode === 'Count')
                        return `${this.y}`
                    else
                        return `${percent}%`
                }
        },
        series: [
            {
                name: "Votes",
                colorByPoint: true,
                data: props?.data?.series
            }
        ]
    }
  return (
    <>
        <HighchartsReact 
            highcharts={Highcharts}
            options={options}
            >
        </HighchartsReact>
        
    </>
  )
}

export default CustomPieChart
